/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteUsersRequestBody
 */
export interface InviteUsersRequestBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUsersRequestBody
     */
    emails: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof InviteUsersRequestBody
     */
    localities?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof InviteUsersRequestBody
     */
    language?: string;
}

export function InviteUsersRequestBodyFromJSON(json: any): InviteUsersRequestBody {
    return InviteUsersRequestBodyFromJSONTyped(json, false);
}

export function InviteUsersRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteUsersRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emails': json['emails'],
        'localities': !exists(json, 'localities') ? undefined : json['localities'],
        'language': !exists(json, 'language') ? undefined : json['language'],
    };
}

export function InviteUsersRequestBodyToJSON(value?: InviteUsersRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emails': value.emails,
        'localities': value.localities,
        'language': value.language,
    };
}

